import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { formValueSelector, reduxForm } from "redux-form";
import { Button, Col, Grid, Row, Jumbotron, Panel } from "react-bootstrap";
import {
  getErgebnisValues,
  inputsFormName
} from "../selectors/inputsSelectors";
import Currency from "./inputs/Currency";
import PrettyNumber from "./inputs/PrettyNumber";
import ErgebnisRow from "./inputs/ErgebnisRow";
import PsLeadModal from "./inputs/PsLeadModal";
import PsOverlayContainer from "./inputs/PsOverlayContainer";

function Ergebnis(props) {
  if (!props.getWarenEinheit) {
    return <div>Leider ist ein Fehler aufgetreten.</div>;
  }
  return (
    <div className="Container">
      <PsLeadModal />
      <Jumbotron>
        <Grid>
          <Panel
            header={
              <h2>
                <strong>Unsere Kostenschätzung für Ihre Anfrage</strong> (in EUR
                pro Monat*)
              </h2>
            }
            bsStyle="success"
          >
            <Row>
              <Col sm={3} style={{ textAlign: "right" }}>
                {" "}
              </Col>
              <Col sm={2} style={{ textAlign: "right" }}>
                <i>Einheit</i>
              </Col>
              <Col sm={2} style={{ textAlign: "right" }}>
                <i>Preis pro Einheit</i>
              </Col>
              <Col sm={2} style={{ textAlign: "right" }}>
                <i>Einheiten</i>
              </Col>
              <Col sm={2} style={{ textAlign: "right" }}>
                <i>Zwischensumme</i>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <h4> Wareneingang </h4>
              </Col>
            </Row>
            <ErgebnisRow
              label="Warenannahme"
              einheit={props.getWarenEinheit}
              preisProEinheit={props.getEinheitspreisWareneingang}
              einheiten={props.getWareneingangsmengeProMonat}
              zwischensumme={props.getPreisWareneingang}
            />
            <Row>
              <Col sm={12}>
                <h4> Lagerung </h4>
              </Col>
            </Row>

            <ErgebnisRow
              label="Lagerplatz pro Monat"
              einheit="pro m³ und Monat"
              preisProEinheit={props.getAnbieter.lagerung}
              einheiten={props.getGesamtLagerplatzProMonat}
              zwischensumme={props.getLagerpreis}
            />
            <Row>
              <Col sm={12}>
                <h4> Kommissionierung </h4>
              </Col>
            </Row>
            <ErgebnisRow
              label="Kommissionierung"
              einheit="pro Pick"
              preisProEinheit={props.getAnbieter.kommissionierung.picking}
              einheiten={props.getAnzahlPicks}
              zwischensumme={props.getPreisPicking}
            />
            <ErgebnisRow
              label="Verpacken"
              einheit="pro Bestellung"
              preisProEinheit={props.getAnbieter.kommissionierung.verpacken}
              einheiten={props.getAnzahlBestellungenProMonat}
              zwischensumme={props.getPreisVerpacken}
            />
            <ErgebnisRow
              label="Packmaterial"
              einheit="pro Bestellung"
              preisProEinheit={
                props.getAnbieter.kommissionierung.verpackungsmaterial
              }
              einheiten={props.getAnzahlBestellungenProMonat}
              zwischensumme={props.getPreisVerpackungsmaterial}
            />

            <Row>
              <Col sm={12}>
                <h4> Versand </h4>
              </Col>
            </Row>

            <ErgebnisRow
              label="Versandkosten"
              einheit="pro Bestellung"
              preisProEinheit={props.getPreisSendung}
              einheiten={props.getAnzahlBestellungenProMonat}
              zwischensumme={props.getPreisVersand}
            />
            {props.getRetourenExist && (
              <Row>
                <Col sm={12}>
                  <h4> Retouren </h4>
                </Col>
              </Row>
            )}
            {props.getRetourenExist && (
              <ErgebnisRow
                label="Rückversand"
                einheit="pro Retoure"
                preisProEinheit={props.getAnbieter.retouren.versand}
                einheiten={props.getAnzahlRetourenProMonat}
                zwischensumme={props.getPreisRetourenversand}
              />
            )}
            {props.getRetourenExist && (
              <ErgebnisRow
                label="Retourenhandling"
                einheit="pro Retoure"
                preisProEinheit={props.getAnbieter.retouren.handling}
                einheiten={props.getAufzubereitendeRetourenmenge}
                zwischensumme={props.getPreisRetouren}
              />
            )}
            <Row>
              <Col sm={12}>
                <h4> Gesamtkosten pro Monat </h4>
              </Col>
            </Row>
            <Row>
              <Col sm={2} />
              <Col sm={2}> </Col>
              <Col sm={2}> </Col>
              <Col sm={2}>
                <strong>Summe</strong>
              </Col>
              <Col sm={2} smOffset={2}>
                <strong>
                  <Currency value={props.getGesamtpreis} />
                </strong>
              </Col>
            </Row>
            <Row>
              <Col sm={2}>
                <Link to="/">
                  <Button type="button" style={{ margin: "30px 0" }}>
                    Angaben ändern
                  </Button>
                </Link>
              </Col>
              <Col sm={2}>
                <PsOverlayContainer />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                {" "}
                <i>
                  *netto exkl. 19% MwSt., unverbindliche Schätzung. Fragen Sie
                  uns gerne nach einem konkreten Angebot.{" "}
                </i>{" "}
              </Col>
            </Row>
          </Panel>
        </Grid>
      </Jumbotron>
    </div>
  );
}

const mapStateToProps = state => {
  return getErgebnisValues(state);
};

const Connected = connect(mapStateToProps)(Ergebnis);

export default reduxForm({
  form: inputsFormName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(Connected);



// WEBPACK FOOTER //
// ./src/components/Ergebnis.js